<li class="nav-item" *ngIf="empresaInSavedFilter">
    <a href="javascript:" (click)="loadFilter()">
        <i class="fa fa-database"></i>
        <span>Carregar Filtro Salvo</span>
       
    </a>
</li>

<li class="nav-item" *ngIf="empresaInSavedFilter">
    <a href="javascript:" (click)="deleteFilter(authService.currentUserValue.selectedEmpresa._id)">
        <i class="fa fa-times"></i>
        <span>Excluir Filtro</span>
       
    </a>
</li>

<li  *ngIf="showFilter" class="nav-item" (click)="elementService.openCloseTreeview($event)">
    <a class="nav-link">
        <i class="nav-icon fas fa-filter"></i>
        <p>
            Filtros
            <i class="right fas fa-angle-left"></i>
        </p>
    </a>
    
    
    
    <ul class="nav nav-treeview">
        <li class="nav-item">
            <a class="nav-link btn bg-gradient-info" href="javascript:" (click)="clearFilters()">
                <i class="nav-icon fa fa-eraser"></i>
                <span>Limpar Filtros</span>
            </a>
            <a class="nav-link btn bg-gradient-success" href="javascript:" (click)="saveFilter()">
                <i class="nav-icon fa fa-save"></i>
                <span>Salvar Filtro</span>
            </a>
        </li>

        <li class="nav-item" *ngFor="let node of dataSource.data" [ngClass]="openCloseTreeview(node)" (click)="treeviwNavControl(node)">
            <a class="nav-link" *ngIf="node.tipo != 'date'">
                <p>
                    {{node.name}}
                    <i class="right fas fa-angle-left"></i>
                </p>
            </a>
            <a class="nav-link" *ngIf="node.tipo == 'date'" (click)="callDataRange(node.solrFieldName, node.core)">
                <p>{{node.name}}
                    <i class="fa fa-angle-left right"></i>
                </p>
            </a>
            <ul class="nav nav-treeview">
                <li class="nav-item" *ngIf="node.tipo == 'date'">
                    <button id="daterange-btn-{{node.solrFieldName}}" 
                        class="btn bg-gradient-info nav-link"
                        >
                        
                        <span></span>
                        <i class="float-right fa fa-caret-down"></i>
                    </button>

                    <button type="button" class="btn bg-gradient-danger nav-link" id="removeFilter-btn-{{node.solrFieldName}}" (click)='removeDateRangeFilter()'>
                        <span>
                        Remover Filtro
                        </span>
                    </button>
                    
                </li>
                <li class="nav-item" >
                    <a class="nav-link" *ngIf="node.tipo != 'date'" id="{{node.solrFieldName}}">
                        <li class="nav-item" *ngIf="node.tipo=='text' && node.children.length > 1">
                            <input class="form-control" type="search" placeholder="filtrar dados" [(ngModel)]="node.inputText" (ngModelChange)="this.searchTextUpdate.next($event)">
                        </li>
                        <li *ngFor="let field of node.children" class="nav-item" (click)="getNode(field)">
                            <a class="nav-link" >
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="field.selected"  />
                                <p 
                                    [matTooltip]="field.name"
                                    [matTooltipPosition]="'above'"
                                    matTooltipHideDelay="2" 
                                    class="asideFilter"> {{field.name}}
                                    <span class="badge badge-success float-right">{{field.count}}</span>
                                </p>

                              </div>
                              
                            </a>
                        </li>
                        
                    </a>
                    
                </li>
            </ul>
        </li>
    </ul>
<!--     
    <ul class="treeview-menu">
        
            <li [class.active]="subitem.link[0] === currentUrl">
                <a [routerLink]="">
                    
                </a>
                <div style="cursor:pointer" (click)="toggle(filters[key].name)">
                        <i [ngClass]="" style="float:left;padding:5px"></i>
                        <h6>{{filters[key].name}}</h6>
                    </div>
                    <div style="border:1px solid #383838" class="col-12">
                        <form [hidden]="!toggleState[filters[key].name].value" style="padding-top:5px;padding-right:20px;padding-bottom:0px;padding-left: 5px;">
                            
                
                        </form>
                    </div>
                 <a *ngIf="subitem.external" [href]="subitem.link" [target]="subitem.target">
                    <i *ngIf="subitem.icon" class="fa fa-{{subitem.icon}}"></i>
                    <span>{{subitem.title}}</span>
                </a> 
            </li>
            
        </ng-container>
    </ul> -->
</li>